var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.timeEnabled || _vm.invoicesEnabled
    ? _c("div", { staticClass: "project-metrics" }, [
        _vm.invoicesEnabled
          ? _c("div", { staticClass: "metric-card" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("projects.overview.total-invoiced")))
              ]),
              _c("strong", [_vm._v(_vm._s(_vm.totalInvoiced))])
            ])
          : _vm._e(),
        _vm.invoicesEnabled
          ? _c("div", { staticClass: "metric-card" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("projects.overview.total-payments")))
              ]),
              _c("strong", [_vm._v(_vm._s(_vm.totalReceived))])
            ])
          : _vm._e(),
        _vm.timeEnabled
          ? _c("div", { staticClass: "metric-card" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("projects.overview.estimated-hours")))
              ]),
              _c("strong", [_vm._v(_vm._s(_vm.formatTimeEstimate))])
            ])
          : _vm._e(),
        _vm.timeEnabled
          ? _c("div", { staticClass: "metric-card" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("projects.overview.hours-worked")))
              ]),
              _c("strong", [_vm._v(_vm._s(_vm.formattedTimeWorked))])
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }